import { InvestorBankAccountsActionTypes } from './action-types';
import { InvestorBankAccountsState } from 'models';
import { Reducer } from 'redux';
import { ActionTypes } from 'store/helpers';

const initialState: InvestorBankAccountsState = {
  bankAccounts: [],
  loading: false,
  error: false,
  sortParams: {
    order: 'asc',
    orderBy: 'Operator.Name',
    type: 'string',
  },
};

export const reducer: Reducer<InvestorBankAccountsState, ActionTypes> = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case InvestorBankAccountsActionTypes.REQUEST_INVESTOR_BANK_ACCOUNTS:
      return { ...state, error: false, loading: true };
    case InvestorBankAccountsActionTypes.REQUEST_INVESTOR_BANK_ACCOUNTS_SUCCESS:
      return { ...state, bankAccounts: action.payload, loading: false };
    case InvestorBankAccountsActionTypes.REQUEST_INVESTOR_BANK_ACCOUNTS_FAILED:
      return { ...state, error: true, loading: false };
    case InvestorBankAccountsActionTypes.SET_SORT_PARAMS:
      return {
        ...state,
        sortParams: {
          ...state.sortParams,
          order: state.sortParams.order === 'asc' ? 'desc' : 'asc',
          orderBy: action.payload.id,
          type: action.payload.type,
        },
      };
    default:
      return state;
  }
};
